import Chip from "@mui/material/Chip";
import { Folder } from "types/qbank/folder";
import { useFilter } from "hooks/filter";
import FolderIcon from "@mui/icons-material/Folder";

const FolderBreadcrumb = ({
  folder,
  disabled,
}: {
  folder: Folder;
  disabled: boolean;
}) => {
  const { searchDispatch } = useFilter();

  const changeFolder = (newFolder: Folder) => {
    searchDispatch({
      type: "CHANGE_FOLDER",
      payload: newFolder,
    });
  };

  return (
    <Chip
      onClick={() => changeFolder(folder)}
      label={folder.name}
      icon={<FolderIcon />}
      disabled={disabled}
    />
  );
};

export default FolderBreadcrumb;
